import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const TITLE_HOME = 'home'
export const CUSTOM_LAYOUT = 'custom layout'
export const BACK = 'back'
export const CHOOSE_COLOR = 'Choose color'
export const UPLOAD_LOGO = 'upload logo'
export const TOGGLE_PROGRESS_BAR = 'toggle progress bar'
export const YES = 'Yes'
export const NO = 'No'
export const PREVIEW = 'Preview'
export const LOADING = 'loading'
export const SAVE_ERROR = 'save error'
export const SURVEY_SAVED = 'survey saved with success'
export const SAVE = 'save'

export default {
  [PORTUGUESE]: {
    [TITLE_HOME]: 'Pagina Inicial',
    [CUSTOM_LAYOUT]: 'Layout Personalizado',
    [BACK]: 'Voltar',
    [CHOOSE_COLOR]:
      'Escolha a paleta de cores que melhor se adapta à sua marca ou pesquisa',
    [UPLOAD_LOGO]: 'Carregue seu logotipo',
    [TOGGLE_PROGRESS_BAR]: 'Vai usar a barra de progresso',
    [YES]: 'Sim',
    [NO]: 'Não',
    [PREVIEW]: 'Visualizar',
    [LOADING]: 'Carregando',
    [SAVE_ERROR]: 'Algo deu errado. Por favor, tente novamente',
    [SURVEY_SAVED]: 'Pesquisa salva com sucesso',
    [SAVE]: 'Salvar',
  },

  [ENGLISH]: {
    [TITLE_HOME]: 'Home',
    [CUSTOM_LAYOUT]: 'Custom Layout',
    [BACK]: 'Back',
    [CHOOSE_COLOR]: 'Choose the color pallet that better fits your brand or survey',
    [UPLOAD_LOGO]: 'Upload your logo',
    [TOGGLE_PROGRESS_BAR]: 'Will use progress bar',
    [YES]: 'Yes',
    [NO]: 'No',
    [PREVIEW]: 'Preview',
    [LOADING]: 'Loading',
    [SAVE_ERROR]: 'Something went wrong. PLease try again',
    [SURVEY_SAVED]: 'Survey saved with success',
    [SAVE]: 'Save',
  },

  [SPANISH]: {
    [TITLE_HOME]: 'Página de Inicio',
    [CUSTOM_LAYOUT]: 'Diseño Personalizado',
    [BACK]: 'Atrás',
    [CHOOSE_COLOR]: 'Elige la paleta de colores que mejor encaje con tu marca o encuesta',
    [UPLOAD_LOGO]: 'Sube tu logotipo',
    [TOGGLE_PROGRESS_BAR]: 'Usará la barra de progreso',
    [YES]: 'Sí',
    [NO]: 'No',
    [PREVIEW]: 'Avance',
    [LOADING]: 'Cargando',
    [SAVE_ERROR]: 'Algo salió mal. Inténtalo de nuevo',
    [SURVEY_SAVED]: 'Encuesta guardada con éxito',
    [SAVE]: 'Guardar',
  },
}
